import { render, staticRenderFns } from "./VerNoticia.vue?vue&type=template&id=35010c8a&"
import script from "./VerNoticia.vue?vue&type=script&lang=js&"
export * from "./VerNoticia.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports